import bg_barrel_right_line from '../../../style/images/bg_barrel_right_line.png';
import bg_barrel_left_person from '../../../style/images/bg_barrel_left_person.png';
import bg_barrel_right_unit from '../../../style/images/bg_barrel_right_unit.png';

const lineImage = new Image();
lineImage.src = bg_barrel_right_line;

const personImage = new Image();
personImage.src = bg_barrel_left_person;

const unitImage = new Image();
unitImage.src = bg_barrel_right_unit

export const barrel_config = {
  options: {
    responsive: true,
    aspectRatio: 1,
    layout: {
      padding: {
        left: 85 * window.innerWidth / 1920,
        right: 150 * window.innerWidth / 1920,
      },
    },
    legend: {
      position: 'left',
      display: false
    },
    plugins: {
      legend: false,
      tooltip: false,
      datalabels: false
    },
    elements: {
      point: {
        pointRadius: 4,
      },
    },
    scales: {
      x: {
        min: 0,
        max: 120,
        ticks: { display: false, stepSize: 10, },
        grid: {
          display: true,
          drawTicks: false,
          borderWidth: 0
        },
      },
      y: {
        min: -120,
        max: 120,
        ticks: { display: false, stepSize: 10 },
        grid: {
          display: true,
          drawTicks: false,
          borderWidth: 0

        },
      },
    }
  },

  plugins: [{
    id: 'custom_canvas_barrel_image',
    beforeDraw: (chart) => {
      if (lineImage.complete) {
        const ctx = chart.ctx;
        const { top, left, width, height } = chart.chartArea;
        const x = left;
        const y = top;
        //console.log('height', height, 'width', width)
        ctx.drawImage(lineImage, x, y, height / 2, height);
      } else {
        lineImage.onload = () => chart.draw();
      }
    }
  },
  {
    id: 'custom_canvas_barrel_image',
    beforeDraw: (chart) => {
      if (personImage.complete) {
        const ctx = chart.ctx;
        const { top, left, width, height } = chart.chartArea;

        const x = left - height / 4;
        const y = top;

        ctx.drawImage(personImage, x, y, height / 4, height);
      } else {
        personImage.onload = () => chart.draw();
      }
    }
  }, {
    id: 'custom_canvas_barrel_image',
    beforeDraw: (chart) => {
      if (unitImage.complete) {
        const ctx = chart.ctx;
        const { top, left, width, height } = chart.chartArea;
        const x = left + height / 2;
        const y = top;

        ctx.drawImage(unitImage, x, y, height / 5, height);
      } else {
        unitImage.onload = () => chart.draw();
      }
    }
  }]
}